import React from "react";
import { CtaButton } from "./CtaButton";
import { Countdown } from "./Countdown";
const summary = [{
  big: "50",
  label: "challenges"
}, {
  big: "6",
  label: "premium volumes"
}, {
  big: "5",
  label: "exclusive bonuses"
}];
export function FinalCta() {
  return <section className="bg-wine-900 px-4 py-16 sm:py-24" aria-labelledby="final-title" data-id="element-103" data-mp="15ddhd6puzrhy">
      <div className="mx-auto max-w-3xl text-center" data-id="element-104" data-mp="15fq92blf5g87">
        <h2 id="final-title" className="font-serif text-3xl font-bold leading-tight text-white sm:text-5xl" data-id="element-105" data-mp="1jc3gst05i39h">
          Ready to stop studying biomechanics <em className="text-wine-200" data-id="element-106" data-mp="1ec7kzh1lxi50">only by reading?</em>
        </h2>
        <p className="mt-4 text-lg text-wine-100" data-id="element-107" data-mp="1t2ewtdx402wq">Start training your judgment through cases.</p>

        <dl className="mx-auto mt-10 grid max-w-xl grid-cols-3 gap-3" data-id="element-108" data-mp="1o4dbsng4htim">
          {summary.map(s => <div key={s.label} className="rounded-2xl bg-wine-800 px-2 py-5" data-id="element-109" data-mp="223w90l7ebkg5">
              <dt className="sr-only" data-id="element-110" data-mp="1x5uodvubnd2k">{s.label}</dt>
              <dd className="font-serif text-4xl font-extrabold text-white sm:text-5xl" data-id="element-111" data-mp="n5m887qsge4i">{s.big}</dd>
              <dd className="mt-1 text-xs font-semibold uppercase tracking-wide text-wine-200 sm:text-sm" data-id="element-112" data-mp="s4pefvii8qe2">{s.label}</dd>
            </div>)}
        </dl>
        <p className="mt-6 font-serif text-xl font-bold italic text-white" data-id="element-113" data-mp="x27f6ymdbzaz">One complete case-based training system.</p>

        <p className="mt-8 text-base font-semibold text-wine-100" data-id="element-114" data-mp="120ilizdgfrog">
          Only <span className="font-serif text-4xl font-extrabold text-white" data-id="element-115" data-mp="163xd8nar9whq">$27</span> USD
        </p>

        <div className="mt-6" data-id="element-116" data-mp="1b1yy9drqs5vu">
          <CtaButton label="Yes — I want access to Biomechanics War Room™" note="Instant access · Lifetime access · One-time payment · 7-Day Guarantee" noteTone="dark" data-id="element-117" data-mp="1b173g55yyc6m" />
        </div>
        <Countdown tone="dark" data-id="element-118" data-mp="1pszdc1mzuy0y" />
        <p className="mt-5 text-sm text-wine-200" data-id="element-119" data-mp="1pu0riezb40mw">Your currency will be automatically converted according to your country.</p>
      </div>
    </section>;
}